<template>
  <div class="fill-height">

    <NavigationDrawer
      :mobileView="mobileView"
      :isDrawerOpen="isDrawerOpen"
    />

    <Toolbar
      :mobileView="mobileView"
      :title="title"
      @openNavigation="isDrawerOpen = !isDrawerOpen"
    />

    <!-- Default slot para o conteúdo a ser exibido -->
    <slot />

  </div>
</template>

<script>
import NavigationDrawer from './NavigationDrawer'
import Toolbar from './Toolbar'
import { mobileViewBreakpoint } from '@/helpers/mobileViewBreakpoint'

/**
 * @group AppNavigation
 * Layout para Toolbar e NavigationDrawer padrão do sistema.
*/
export default {
  name: 'AppNavigation',

  components: {
    NavigationDrawer,
    Toolbar
  },

  props: {
    // Titulo da toolbar
    title: {
      type: String,
      default: 'Painel de Responsáveis'
    }
  },

  data: () => ({
    isDrawerOpen: false
  }),

  computed: {
    mobileView () {
      return mobileViewBreakpoint(this.$vuetify.breakpoint.name)
    }
  },

  /** @vuese
  * Alterna estado do NavigationDrawer
  */
  methods: {
    toggleDrawer () {
      this.isDrawerOpen = !this.isDrawerOpen
    }
  }
}
</script>

<style lang="stylus" scoped>
.navdrawer{
  display flex
  flex-direction column
}
</style>
